import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useScreenTime(
  screen: string,
  metadata?: Record<string, unknown>,
  enabled = true,
) {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id || !enabled) return;

    let logId: string | null = null;
    const enteredAt = new Date();

    supabase
      .from("screen_time_logs" as any)
      .insert({
        user_id: user.id,
        screen,
        entered_at: enteredAt.toISOString(),
        metadata: metadata ?? null,
      })
      .select("id")
      .single()
      .then(({ data }) => {
        logId = (data as any)?.id ?? null;
      });

    return () => {
      if (!logId) return;
      const exitedAt = new Date();
      const duration = Math.round((exitedAt.getTime() - enteredAt.getTime()) / 1000);
      supabase
        .from("screen_time_logs" as any)
        .update({
          exited_at: exitedAt.toISOString(),
          duration_seconds: duration,
        })
        .eq("id", logId);
    };
  }, [user?.id, screen, enabled]);
}
